import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { addToast, useModals } from 'core/notifications';
import { Form } from 'core/forms';
import i18n from 'i18next';

import useGlobalQueries from '../hooks/useGlobalQueries';

import getBulkImportModalSchema from '../schemas/getBulkImportModalSchema';

import NewItemFormButtons from './newItemFormButtons';

const BulkImportModalForm = ({
  dataErrors = null,
  hasPreview = false,
  isSubmitting = false,
  model = {},
  onSubmit = () => {},
  onUpdate = () => {},
}) => {
  const { adminSettings } = useGlobalQueries();
  const [formState, setFormState] = useState({});
  const { removeModal } = useModals();

  useEffect(() => {
    if (!dataErrors) return;

    dataErrors.forEach(({ message, source }) => {
      const field = formState[source.split('data.').pop()];

      if (field) {
        Object.assign(field, { error: message, hasError: true });
      }
    });

    addToast(i18n.t('form-errors'), 'warning');
  }, [dataErrors, formState]);

  const handleCancel = () => {
    if (!hasPreview) return removeModal();

    const { csv_preview: csvPreview, id, ...rest } = model;

    onUpdate(rest);
  };

  const handleLoad = (state) => {
    setFormState(state.formState);
  };

  const handleUpdate = (state) => {
    setFormState(state.formState);
    onUpdate({ ...model, ...state.update });
  };

  return (
    <div>
      <Form
        model={model}
        onLoad={handleLoad}
        onUpdate={handleUpdate}
        schema={getBulkImportModalSchema({ adminSettings, hasPreview })}
      />
      <NewItemFormButtons
        cancelText={hasPreview ? i18n.t('upload-a-different-file') : ''}
        hasError={Object.values(formState).some(({ hasError }) => hasError)}
        isFullScreen
        isSubmitting={isSubmitting}
        onCancel={handleCancel}
        onSubmit={onSubmit}
        submitText={i18n.t('import')}
      />
    </div>
  );
};

BulkImportModalForm.propTypes = {
  dataErrors: PropTypes.arrayOf(
    PropTypes.shape({ message: PropTypes.string, source: PropTypes.string }),
  ),
  hasPreview: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  model: PropTypes.shape({}),
  onSubmit: PropTypes.func,
  onUpdate: PropTypes.func,
};

export default React.memo(BulkImportModalForm);
